import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';
import isSmartMeterViewEnabled from 'portal/src/pages/smartMeters/isSmartMeterViewEnabled';
import SmartMeterView from 'portal/src/pages/smartMeters/SmartMeterView';

import { RouteDefinition } from './routeGenerator';

export const smartMetersRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <SmartMeterView
        slug={DASHBOARD_SLUGS.SMART_METERS.HOURLY}
        disabledSlug={DASHBOARD_SLUGS.SMART_METERS.PREVIEW}
      />
    ),
    path: NESTED_ROUTES.SMART_METERS.HOURLY,
    description: ' Analyze smart meter hourly data',
    name: 'Hourly Trends',
  },
  {
    element: <SmartMeterView slug={DASHBOARD_SLUGS.SMART_METERS.WEEKLY} />,
    path: NESTED_ROUTES.SMART_METERS.WEEKLY,
    shouldRenderLink: isSmartMeterViewEnabled,
    description: 'Analyze smart meter weekly trend profiles',
    name: 'Weekly trends',
  },
  {
    element: <SmartMeterView slug={DASHBOARD_SLUGS.SMART_METERS.MONTHLY} />,
    path: NESTED_ROUTES.SMART_METERS.MONTHLY,
    shouldRenderLink: isSmartMeterViewEnabled,
    description: 'Analyze smart meter monthly trend profiles',
    name: 'Monthly Trends',
  },
  {
    element: <SmartMeterView slug={DASHBOARD_SLUGS.SMART_METERS.BASELINES} />,
    path: NESTED_ROUTES.SMART_METERS.BASELINES,
    shouldRenderLink: isSmartMeterViewEnabled,
    description: 'Use predicted baseline models to identify anomalies',
    name: 'Meter Baselines',
  },
];
